module.exports = __webpack_public_path__ + "img/create-upload.fac3fd63.svg";